module.exports = __webpack_public_path__ + "static/pic01-65f7e44e2756390ab1b2f1b0269e66c0.jpg";